import { useMutation } from '@apollo/client';
import { Box, Button, Container, Flex, Icon, theme } from '@energiebespaarders/symbols';
import { Medium } from '@energiebespaarders/symbols/helpers';
import { ArrowLeft } from '@energiebespaarders/symbols/icons/line';
import { Mailbox } from '@phosphor-icons/react';
import { useKeyPressEvent } from 'react-use';
import { useMe } from '~/hooks/useMe';
import type { me_me_Customer } from '~/types/generated/me';
import type {
  updateConsentCustomer,
  updateConsentCustomerVariables,
} from '~/types/generated/updateConsentCustomer';
import { createMarketingConsent } from '~/utils/createConsent';
import { UPDATE_CONSENT_CUSTOMER } from '../_app/ConsentModal';
import OmniformCard from '../Omniform/OmniformCard';

interface ExitCardProps {
  onNext: () => void;
  onPrevious: () => void;
}

const IntakeMarketingConsentCard: React.FC<ExitCardProps> = ({ onNext, onPrevious }) => {
  const { me } = useMe<me_me_Customer>();

  const [addMarketingConsent] = useMutation<updateConsentCustomer, updateConsentCustomerVariables>(
    UPDATE_CONSENT_CUSTOMER,
    {
      variables: {
        userId: me.id,
        customer: {
          consent: [...me.consent, createMarketingConsent('intake-card')],
        },
      },
    },
  );
  const handleAcceptConsent = () => {
    void addMarketingConsent();
    onNext();
  };
  const handleRefuseConsent = () => {
    onNext();
  };

  useKeyPressEvent('ArrowLeft', onPrevious);

  return (
    <OmniformCard p={4} animation="none" id="omniform-marketing-consent">
      <Flex flexWrap="wrap">
        <Box width={1}>
          <Icon icon={ArrowLeft} stroke="gray" onClick={onPrevious} />
        </Box>

        <Box width={1} pt={5}>
          <Container size="md" textAlign="center">
            <Mailbox weight="duotone" color={theme.colors.green} size={64} />
            <p style={{ fontSize: theme.type.scale[4], letterSpacing: '-0.025em' }}>
              <Medium>Wil je meer informatie ontvangen over verduurzaming?</Medium>
            </p>
            <p>
              Je ontvangt dan een aantal e-mails met meer info, lopende acties en bespaartips. Je
              kunt je altijd afmelden voor deze mails.
            </p>
          </Container>
        </Box>

        <Box width={1} textAlign="center" py={[5, 5, 10]}>
          <Button
            onClick={handleRefuseConsent}
            style={{ borderRadius: 3 }}
            bgColor="grayDarker"
            inverse
            px={5}
            py={2}
            mr={2}
            mb={0}
          >
            Nee, bedankt
          </Button>
          <Button
            bgColor="yellow"
            color="grayBlack"
            onClick={handleAcceptConsent}
            style={{ borderRadius: 3 }}
            px={5}
            py={2}
            mr={0}
            mb={0}
          >
            Graag!
          </Button>
        </Box>
      </Flex>
    </OmniformCard>
  );
};

export default IntakeMarketingConsentCard;
